import * as Type from './actionsTypes';

const INITIAL_STATE = {
  municipioUsuario: null,
  feriados: [],
  loadingCalendario: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO_SUCCESS: {
      return {
        ...state,
        municipioUsuario: action.data,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_PUBLICO: {
      return {
        ...state,
        loadingCalendario: true,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_PUBLICO_SUCCESS: {
      return {
        ...state,
        feriados: action.data,
        loadingCalendario: false,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_PUBLICO_FAIL: {
      return {
        ...state,
        loadingCalendario: false,
      };
    }
    case Type.CALENDARIO_FERIADO_CLEAN: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getMunicipioUsuario = (state) => state.rootState.calendarioFeriado.municipioUsuario;
export const getFeriados = (state) => state.rootState.calendarioFeriado.feriados;
export const getLoadingCalendario = (state) => state.rootState.calendarioFeriado.loadingCalendario;
